<template>
    <v-card>
        <Toolbar :toolbarTitle="computedTitle" :lastPath="-1" :showDrawer="false" />
        <Topics :isAdmin="true" :isCourseManagerValue="isCourseManagerValue" />
    </v-card>
</template>

<script>
import CourseMixin from '../../../Components/CourseLearning/CourseManager/Mixins/CourseMixin';
import Toolbar from '../../../Components/Generic/Toolbar';
import Topics from '../../../Components/CourseLearning/CourseManager/Topics';

export default {
    name: 'topics',
    mixins: [CourseMixin],
    components: { Toolbar, Topics },
    data: () => ({
        tabs: 0,
        isCourseManagerValue: false
    }),
    computed: {
        computedTitle() {
            if (this.getSelectedAdminCourse.topicTypeName !== null) {
                return `${this.$t('Kursmanager')} - ${this.getSelectedAdminCourse.topicTypeName}`;
            }
            return `${this.$t('Kursmanager')} - ${this.$t('Themen')}`;
        },

        permissions() {
            return {
                add: this.isCourseManagerValue,
                update: this.isCourseManagerValue,
                delete: this.isCourseManagerValue,
                eval: this.isCourseManagerValue && this.getSelectedAdminCourse.useEvaluation
            };
        },
        isSelected() {
            return Object.keys(this.getSelectedTopic).length > 0;
        }
    },
    methods: {
        // goToEvaluations() {
        //     this.$router.push({ name: 'evaluations' });
        // },
        // goToGradingTables() {
        //     this.$router.push({ name: 'gradingTables' });
        // },
        // create() {
        //     this.operationType = 'ADD';
        //     this.showModal = true;
        // },
        // update() {
        //     this.operationType = 'UPDATE';
        //     this.showModal = true;
        // },
        // deleteTopicEmit() {
        //     this.showDeleteModal = true;
        // }
    },
    mounted() {
        this.GET_TOPIC_PICTURE();
        this.isCourseManager().then((response) => (this.isCourseManagerValue = response));
    }
};
</script>
